import React from "react";
import { Navigate } from "react-router-dom";
import useAuth from "../../hooks/useAuth";
import { isPlatformAdmin, isTenantAdmin } from "../../util/accessControl";
import ChatbotClientsPage from "./chatbot/ChatbotClientsPage";
import ChatbotClientDetailPage from "./chatbot/ChatbotClientDetailPage";

export default function WorkspaceDashboardPage() {
  const { user } = useAuth();
  if (isPlatformAdmin(user)) return <ChatbotClientsPage />;
  if (isTenantAdmin(user) && user.client_id != null) return <ChatbotClientDetailPage dashboardClientId={user.client_id} />;
  return <Navigate to="/agents" replace />;
}
